export enum PoultryContextKeys {
  POULTRYNEXT = 'poultrynext',
  OBSERVATIONS_SWITCH = 'observationSwitch',
  FARMER_INSIGHTS_BENCHMARK_SETTINGS = 'farmerInsightsBenchmarkSettings',
  CYCLES_SELECTED_CYCLE_ID = 'cyclesSelectedCycleId',
  CYCLES_SELECTED_BARN_ID = 'cyclesSelectedBarnId',
  CYCLES_IS_DETAILED_OVERVIEW = 'cycleIsDetailedOverview',
  FARMER_INSIGHTS_LOCAL_FILTER_SETTINGS = 'farmerInsightsLocalFilterSettings',
  FARMER_INSIGHTS_GLOBAL_FILTER_SETTINGS = 'farmerInsightsGlobalFilterSettings',
  PRODUCTS_COUNTRY = 'productsCountry',
  STANDARD_REFERENCE_VALUE_SHEETS_COUNTRY = 'standardRefValSheetsCountry',
  REFERENCE_SCHEMES_COUNTRY = 'referenceSchemesCountry',
  REFERENCE_FEED_ADVICE = 'referenceFeedAdvice',
  REFERENCE_VALUE_SHEET = 'referenceValueSheet',
  RVS_TEMPERATUREINSIDE_UNIT = 'temperatureInside',
  RVS_FEEDINTAKE_UNIT = 'feedIntake',
  RVS_WATERINTAKE_UNIT = 'waterIntake',
  RVS_WEIGHT_UNIT = 'weight',
  RVS_COLUMN_SETTINGS = 'columnSettings',
  RVS_SETTINGS = 'rvsSettings',
  FARM_RESULT_SETTINGS = 'FarmResultSettings',
  DAYOFFSET = 'DayOffset',
  UNIT_OF_MEASURE_SETTINGS = 'unitOfMeasureSettings',
  VETERINARIAN_SETTINGS = 'veterinarianSettings',
  FINALSETUP_SETTINGS = 'finalSetupSettings',
  DISCOUNT_SETTINGS = 'discountSettings',
}

export const MIN_FLOCKS_FOR_BENCHMARK = 15;

export const VatPercentages: number[] = [0, 7, 9, 21];
